import { createSidecarMedium as e } from "./index.es487.js";
var a = e();
export {
  a as effectCar
};
//# sourceMappingURL=index.es447.js.map
